export default function () {
  return {
    query: '',
    listings: [],
    totals: {},
  }
}
